import { DOC_TYPES, DOC_STATE } from '../constants/patientCard';

/**
 * admissionDocumentLabels — pure §1.4 `DocumentDescriptor` → display-text
 * derivation, shared by `AdmissionDocumentButtons.jsx` (the interactive
 * on-screen buttons) and `printPatientCard.js` (the static print line for
 * the same admission). Extracted (F10) so the two surfaces can never drift
 * on wording — this module has NO API import and makes NO network call;
 * it only maps already-resolved descriptor fields to established copy.
 */

// Base label per doc_type (mockup icons: 📑 discharge summary, 🧾 diagnostics
// bill, 🧮 invoice). `hasStateBand` marks the two MONEY documents — the only
// ones ever carrying an INTERIM/DRAFT/FINAL/CANCELLED band (R2-1: a
// discharge summary or dues acknowledgement is a lifecycle marker only and
// never renders one).
export const DOC_BUTTON_META = [
  { docType: DOC_TYPES.DISCHARGE_SUMMARY, icon: '📑', label: 'Discharge Summary', hasStateBand: false },
  { docType: DOC_TYPES.DIAGNOSTICS_BILL, icon: '🧾', label: 'Diagnostics Bill', hasStateBand: true },
  { docType: DOC_TYPES.INVOICE, icon: '🧮', label: 'Invoice', hasStateBand: true, interimLabel: 'Interim Bill' },
];

// `unavailable_reason_code` → why the button/line is disabled (must always
// say why — a disabled affordance must never look broken). `NOT_ISSUED`
// means a different thing per `doc_type`: the row only ever knows whether a
// bill NUMBER was minted, never whether charges exist, so the diagnostics
// text must not claim "nothing to bill" (F8-F #5) — it gets its own string.
export const REASON_TEXT = {
  ADMISSION_CANCELLED: 'This admission was cancelled.',
  NOT_DISCHARGED: 'Available once the admission is closed.',
  NOT_ISSUED: "This document hasn't been issued yet — there is nothing to open.",
  NO_DUES: 'No outstanding dues to acknowledge.',
};
export const NOT_ISSUED_DIAGNOSTICS_TEXT = 'No diagnostics bill was issued for this admission.';
export const REASON_FALLBACK = "This document isn't available for this admission.";

export function reasonFor(docType, reasonCode) {
  if (reasonCode === 'NOT_ISSUED' && docType === DOC_TYPES.DIAGNOSTICS_BILL) return NOT_ISSUED_DIAGNOSTICS_TEXT;
  return REASON_TEXT[reasonCode] || REASON_FALLBACK;
}

export function bandedLabel(meta, state) {
  if (!meta.hasStateBand) return meta.label;
  switch (state) {
    case DOC_STATE.INTERIM: return meta.interimLabel || `${meta.label} (interim)`;
    case DOC_STATE.DRAFT: return `${meta.label} (draft)`;
    case DOC_STATE.CANCELLED: return `${meta.label} (cancelled — view only)`;
    default: return meta.label; // FINAL / NOT_ISSUED / NOT_AVAILABLE — plain
  }
}

// Inline line shown next to a CANCELLED-but-viewable document.
export const CANCELLED_NOTE = 'This document was cancelled. It stays on record and can still be viewed.';
